<ag-grid-angular
  class="ag-theme-alpine ag-theme-lum"
  [columnDefs]="columnDefs"
  [gridOptions]="gridOptions"
  (gridReady)="onGridReady($event)"
  [style.height]="height"
  [style.width]="width"
></ag-grid-angular>
